<div class="loader-container">
  <mat-spinner diameter="50"></mat-spinner>
  <span class="loading-text">{{ 'MESSAGES.LOADER.PLEASE_WAIT' | translate }}</span>
</div>
